// @core/api/endpoints/document/instantiate_document_from_template.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentResponse,
  InstantiateDocumentFromTemplateRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Instantiate document from template
 * Creates a new Document from the template, fills variables, resolves conditional blocks, and auto-creates linked companion documents. Preferred entry point for the contract template library (supersedes CreateDocumentFromTemplate for contract flows).
 */
export async function InstantiateDocumentFromTemplate(
  template_id: string,
  data: InstantiateDocumentFromTemplateRequest,
  options?: RequestOptions
): Promise<DocumentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-templates/:template_id/instantiate`;
  requestPath = requestPath.replace(':template_id', encodeURIComponent(template_id));
  const requestOptions = options;
  return client.post<DocumentResponse>(requestPath, data, requestOptions);
}
